module.exports = __webpack_public_path__ + "static/OrbitalLowTabs-d908e7c066b7a467cc1ed573aa83d270.jpg";